document.addEventListener("DOMContentLoaded", function () {
  function handleFade() {
    document.querySelectorAll(".tile-left").forEach(function (elem) {
      var distInView = elem.getBoundingClientRect().top - window.innerHeight;

      if (distInView < 0) {
        elem.classList.add("in-left");
      } else {
        elem.classList.remove("in-left");
      }
    });

    document.querySelectorAll(".tile-right").forEach(function (elem) {
      var distInView = elem.getBoundingClientRect().top - window.innerHeight;

      if (distInView < 0) {
        elem.classList.add("in-right");
      } else {
        elem.classList.remove("in-right");
      }
    });

    document.querySelectorAll("img.image-fit").forEach(function (elem) {
      var distInView = elem.getBoundingClientRect().top - window.innerHeight;

      if (distInView < 0) {
        elem.classList.add("in-fade");
      } else {
        elem.classList.remove("in-fade");
      }
    });
  }

  window.addEventListener("scroll", handleFade);
  handleFade();
});
